import axios from "../../../axios"

export default {
  async fetchGroupsOfCustomer(
    token,
    tenantIds= [],
    search = '',
    page = 1,
    limit = 4,
  ) {
    try {
      axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/groups_of_customer';
      return await axios.get('', {
        params: {
          search: search,
          tenant_ids: tenantIds,
          pagination_page: page,
          pagination_limit: limit
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}